<script lang="ts">
  // HR Continuity view (Phase 4, spec 5.7) — "Trends": read-only aggregates
  // only. No per-person risk data, no OKR data, no names on exit notes.
  import { createQuery } from '@tanstack/svelte-query';
  import { hrContinuityApi } from '$lib/api/hrContinuity';

  const query = createQuery(() => ({ queryKey: ['hr-continuity-trends'], queryFn: () => hrContinuityApi.trends() }));
</script>

<div class="tym-page">
  {#if query.isLoading}
    <div class="tym-loading-state">Loading...</div>
  {:else if query.isError}
    <div class="tym-error-state">Could not load trends.</div>
  {:else if query.data}
    {@const t = query.data}
    <div class="grid grid-cols-1 gap-5 lg:grid-cols-2">
      <div class="tym-card p-5">
        <p class="text-[13px] font-semibold text-dark-gray">Headcount</p>
        <p class="mt-1 tym-stat-value text-4xl">{t.headcount}</p>
      </div>

      <div class="tym-card space-y-2 p-5">
        <p class="tym-section-title">Average tenure by group</p>
        {#each t.average_tenure_by_department as row (row.department)}
          <p class="text-[13px] text-toyama-heavy-carbon">{row.department}: {row.avg_tenure_months.toFixed(1)} months</p>
        {:else}
          <p class="text-[13px] text-dark-gray">No data yet.</p>
        {/each}
      </div>

      <div class="tym-card space-y-2 p-5">
        <p class="tym-section-title">Joiners by month (last 12 months)</p>
        {#each t.joiners_by_month as row (row.month)}
          <p class="text-[13px] text-toyama-heavy-carbon">{row.month}: {row.count}</p>
        {:else}
          <p class="text-[13px] text-dark-gray">None.</p>
        {/each}
      </div>

      <div class="tym-card space-y-2 p-5">
        <p class="tym-section-title">Leavers by month (last 12 months)</p>
        {#each t.leavers_by_month as row (row.month)}
          <p class="text-[13px] text-toyama-heavy-carbon">{row.month}: {row.count}</p>
        {:else}
          <p class="text-[13px] text-dark-gray">None.</p>
        {/each}
      </div>

      <div class="tym-card space-y-2 p-5 lg:col-span-2">
        <p class="tym-section-title">Exit notes</p>
        {#each t.exit_notes as note (note.date + note.note)}
          <p class="text-[13px] text-toyama-heavy-carbon">{note.date} — {note.note || '—'}</p>
        {:else}
          <p class="text-[13px] text-dark-gray">None yet.</p>
        {/each}
      </div>
    </div>
  {/if}
</div>
